import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LoaderService } from 'src/shared/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  public inlineHTMLtemplate: SafeHtml;
  private loadingImage = '/assets/icons/icon-58x70.png'
  constructor(
    private loaderService: LoaderService,
    private _sanitizer: DomSanitizer,
    private _cdr: ChangeDetectorRef
  ) {
    localStorage.setItem('notificationCountLimit', '10');
  }

  public get dynamicLoaderText() {
    return this.loaderService.loaderText;
  }

  ngAfterViewInit(): void {
    this.inlineHTMLtemplate = this._sanitizer.bypassSecurityTrustHtml(`<!DOCTYPE html> <html> <head> <style> /* Firefox old*/ @-moz-keyframes blink { 0% { opacity:1; } 50% { opacity:0; } 100% { opacity:1; } } @-webkit-keyframes blink { 0% { opacity:1; } 50% { opacity:0; } 100% { opacity:1; } } /* IE */ @-ms-keyframes blink { 0% { opacity:1; } 50% { opacity:0; } 100% { opacity:1; } } /* Opera and prob css3 final iteration */ @keyframes blink { 0% { opacity:1; } 50% { opacity:0; } 100% { opacity:1; } } .blink-image { -moz-animation: blink normal 2s infinite ease-in-out; /* Firefox */ -webkit-animation: blink normal 2s infinite ease-in-out; /* Webkit */ -ms-animation: blink normal 2s infinite ease-in-out; /* IE */ animation: blink normal 2s infinite ease-in-out; /* Opera and prob css3 final iteration */ } </style> </head> <body> <img class="blink-image" src="${this.loadingImage}"> </body> </html>`);
    this._cdr.detectChanges();
  }
}
